import React from "react";
import { Container, Typography, Paper, Box, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

function Info() {
  return (
    <Container component="main" maxWidth="lg">
      <Box
        sx={{
          marginTop: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Paper elevation={3} sx={{ p: 4, width: "100%" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 4,
            }}
          >
            <Typography variant="h4" component="h1" gutterBottom>
              Auktion der Original Spieltrikots – Alle Infos auf einen Blick
            </Typography>
          </Box>

          <Typography paragraph>
            Willkommen zur Online-Auktion unserer Original Spieltrikots! Der
            gesamte Erlös dieser Versteigerung kommt direkt unserem Nachwuchs
            zugute. Unterstütze unsere jungen Talente und sichere dir ein echtes
            Stück Dragons-Geschichte!
          </Typography>

          <Box sx={{ my: 3 }}>
            <Typography variant="h5" gutterBottom color="secondary">
              So funktioniert die Auktion:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Typography component="li">
                <strong>Auktion nur online:</strong> Eine Gebotsabgabe vor Ort
                ist nicht möglich.
              </Typography>
              <Typography component="li">
                <strong>Startgebot:</strong> Jedes Trikot startet bei 60 Euro.
              </Typography>
              <Typography component="li">
                <strong>Gebotserhöhung:</strong> Mindestens 10 € (höhere Gebote
                sind natürlich möglich).
              </Typography>
              <Typography component="li">
                <strong>Ende der Versteigerung:</strong> Samstag, 28.03.2026 um
                19:00 Uhr.
              </Typography>
              <Typography component="li">
                <strong>Soft-Close:</strong> Wird innerhalb der letzten 3
                Minuten ein Gebot abgegeben, verlängert sich die Auktion für
                dieses Trikot automatisch um weitere 3 Minuten. Die Auktion endet
                erst, wenn innerhalb dieser Verlängerung kein Gebot mehr eingeht.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ my: 3 }}>
            <Typography variant="h5" gutterBottom color="secondary">
              Weitere Details:
            </Typography>
            <Box component="ul" sx={{ pl: 2 }}>
              <Typography component="li">
                <strong>Mehrere Trikots:</strong> Eine Person kann
                selbstverständlich mehrere Trikots ersteigern.
              </Typography>
              <Typography component="li">
                <strong>Zahlung:</strong> Vor Ort in bar oder mit Karte.
              </Typography>
              <Typography component="li">
                <strong>Trikotübergabe:</strong> Die Trikots werden im Anschluss
                persönlich von den Spielern übergeben.
              </Typography>
              <Typography component="li">
                <strong>Datenschutz:</strong> Alle erhobenen Daten werden
                ausschließlich für die Durchführung der Auktion genutzt und
                direkt im Anschluss gelöscht.
              </Typography>
              <Typography component="li">
                <strong>Rechtsweg:</strong> Der Rechtsweg ist ausgeschlossen.
              </Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography paragraph>
              Viel Erfolg beim Mitbieten und danke für deine Unterstützung
              unserer Nachwuchsarbeit!
            </Typography>
            <Typography paragraph variant="body2" color="text.secondary">
              Deine Kufstein Dragons
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
              }}
            >
              <img
                src="/hck_logo_x140_minfied.svg"
                alt="Kufstein Dragons Logo"
                style={{
                  height: "50px",
                  width: "auto",
                }}
              />
            </Box>
            <Button
              sx={{ mt: 2 }}
              color="secondary"
              component={RouterLink}
              to="/"
              variant="contained"
            >
              Zurück zum Dashboard
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
}

export default Info;
